// Mock product data for Brown Bag Dry Fruits
export const mockProducts = [
  {
    id: 1,
    name: "Afghani White Mamra",
    price: 2600,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/wdu3bj8p_19%20white%20mamra.jpeg",
    description: "Rare white mamra almonds from Afghanistan, known for superior quality and rich oil content"
  },
  {
    id: 2,
    name: "Afghani Mamra Badam",
    price: 1400,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/hr86q7yz_Afghani%20Mamra.jpeg",
    description: "Rich source of proteins, minerals & vitamins. Prevents coronary artery disease & strokes by favoring healthy blood lipid profile"
  },
  {
    id: 3,
    name: "Pecan Nuts",
    price: 1200,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/0z8ou5m0_Pecan%20%20Nuts.jpeg",
    description: "Premium quality pecan nuts, rich in antioxidants and healthy fats"
  },
  {
    id: 4,
    name: "Irani Mamra",
    price: 2100,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/gscqy6z3_irani%20mamra.jpeg",
    description: "Premium Iranian mamra almonds, naturally grown with superior taste and nutrition"
  },
  {
    id: 5,
    name: "Walnut Kernels",
    price: 900,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/kwx9m2i1_Walnut.jpeg",
    description: "Fresh walnut kernels, perfect for brain health and rich in omega-3 fatty acids"
  },
  {
    id: 6,
    name: "Dried Strawberries",
    price: 780,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/ikfrpfqw_WhatsApp%20Image%202026-02-01%20at%2018.44.37%20%281%29.jpeg",
    description: "Natural dried strawberries without added sugar, healthy strawberry snack"
  },
  {
    id: 7,
    name: "Afghani Green Tea",
    price: 875,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/n4x1lkxp_Green%20Tea%20%282%29.png",
    description: "Premium loose leaf Afghani green tea, rich in antioxidants for healthy living"
  },
  {
    id: 8,
    name: "Vacuum Roasted Vegetables",
    price: 1050,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/hg38a5su_Premium%20Air%20Fried%20Snacks.jpeg",
    description: "Premium air-fried vegetable snacks - vacuum roasted, not fried. Contains carrot, potato, sweet potato, beetroot, okra, beans, radish & pumpkin"
  },
  {
    id: 9,
    name: "Kandhari Kishmish",
    price: 800,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/jqtsh3vf_kandhari%20Raisins.jpeg",
    description: "Premium Kandhari raisins, naturally sweet and packed with essential nutrients"
  },
  {
    id: 10,
    name: "Macadamia Nuts",
    price: 960,
    weight: "400g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/y7nady63_Macadamia%20Nuts%20.jpeg",
    description: "Buttery smooth macadamia nuts, handpicked for premium quality"
  },
  {
    id: 11,
    name: "Afghani Jumbo Anjeer",
    price: 1200,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/lzfvsmic_Figs%20%28Anjeer%29%20-%20Copy.jpeg",
    description: "Premium jumbo figs from Afghanistan, naturally sweet and packed with fiber"
  },
  {
    id: 12,
    name: "Jumbo Medjoul Dates",
    price: 1100,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/7iksanpe_Medjoul%20jumbo.jpeg",
    description: "Large, soft and naturally sweet Medjoul dates, perfect for energy and nutrition"
  },
  {
    id: 13,
    name: "Benin Cashew W240 (Sweet & Crispy)",
    price: 770,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/h1strne1_Cashew%20W180.jpeg",
    description: "Premium Benin cashews W240 grade, sweet and crispy texture with rich flavor"
  },
  {
    id: 14,
    name: "Afghani Gurbandi",
    price: 700,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/4f5x5wlm_Afghani%20Gurbandi.jpeg",
    description: "Premium Afghani Gurbandi almonds, small but packed with intense flavor and nutrients"
  },
  {
    id: 15,
    name: "Ajwa Dates",
    price: 825,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/8213n6hl_Ajwa%20Dates.jpeg",
    description: "Premium Ajwa dates, naturally sweet and nutritious with rich health benefits"
  },
  {
    id: 16,
    name: "Melon Seeds",
    price: 875,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/bi17j8b5_melon%20seeds%20for%20site.jpeg",
    description: "Roasted melon seeds, crunchy and packed with protein and healthy fats"
  },
  {
    id: 17,
    name: "Watermelon Seeds",
    price: 240,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/k1bp7c3f_Water%20Melon%20Seeds.jpg",
    description: "Fresh watermelon seeds, rich in minerals and perfect for healthy snacking"
  },
  {
    id: 18,
    name: "Mango Slice",
    price: 430,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/ll2j5kbe_MASL350XBCJ100%20Mango%20Slice.JPG",
    description: "Dried mango slices, naturally sweet and tangy tropical delight"
  },
  {
    id: 19,
    name: "Elaichi (Cardamom)",
    price: 2500,
    weight: "500g",
    image: "https://customer-assets.emergentagent.com/job_premium-nuts-snacks/artifacts/1ieayhhj_Elaichi.jpeg",
    description: "Premium green cardamom, aromatic spice for culinary and health benefits"
  }
];

export const mockReviews = [
  {
    id: 1,
    name: "Priya Sharma",
    rating: 5,
    comment: "Excellent quality dry fruits! Fresh and perfectly packed.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    rating: 5,
    comment: "Best quality almonds I've ever purchased. Highly recommended!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Anita Verma",
    rating: 5,
    comment: "Fast delivery and premium products. Will order again!",
    date: "3 weeks ago"
  }
];
